import './bookingwidget.ts';
import './script.js';
import './slider.ts';
import './cookie-consent.ts';

import 'flexslider';
